<template>
	<!-- T&C -->
	<modal class="integration-modal" :size="'large'" :show-close="false" @close="isVisible = false" v-if="isVisible">
		<template slot="header">
			<h3><i class="material-icons">book</i>Terms &#38; Conditions</h3>
		</template>
		<template slot="body">
			<div class="terms-conditions mb-4">
				<iframe :src="agreementUrl" class="w-100">
				</iframe>
			</div>
		</template>
		<template slot="footer">
			<!-- <button
				type="button"
				class="btn btn-default"
				@click="isVisible = false">
				Cancel
			</button> -->
			<button type="button" class="btn btn-primary" :class="{ 'is-loading': isAccepting }" @click="accept">
				I ACCEPT THE TERMS &#38; CONDITIONS
			</button>
		</template>
	</modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import { AGREEMENTS_VERSION } from '@/lib/statics';
import { duplicateVar } from '@/lib/helper';
import userApi from '@/api/user';

export default {
	name: 'TncModal',
	components: {
		Modal,
	},
	data() {
		return {
			terms: '',
			isVisible: false,
			isAccepting: false,
			sellerAgreementUrl: 'https://docs.google.com/document/d/e/2PACX-1vQCxrhUKofyBKfZezhqFNgMrbQXR9UnYuDWd5MXK99IwAkPpU2dob_Nn_eMIBLCUA/pub?embedded=true',
			supplierAgreementUrl: 'https://docs.google.com/document/d/e/2PACX-1vQbzip4z0rmIf4dNiIHxbqii4LR0HjqEPJoULFo96PQ7goimGJfQTuEXkKWZpPKVbGAsz0ejpMaWLGM/pub?embedded=true',
		};
	},
	methods: {
		...mapActions({
			setUser: 'setUser',
		}),
		checkAgreement() {
			let isAccepted = false;
			if (this.isOwner) {
				const settings = duplicateVar(this.user.settings);
				if (settings.agreements) {
					const agreements = settings.agreements;
					const agreementName = 'ostock';
					const agreement = agreements.find(({ name }) => name === agreementName);
					if (agreement) {
						isAccepted = agreement.accepted && agreement.version === AGREEMENTS_VERSION.INVENTRO;
					}
				}
			} else {
				isAccepted = true;
			}
			this.isVisible = !isAccepted;

			return isAccepted;
		},
		accept() {
			this.isAccepting = true;
			const settings = duplicateVar(this.user.settings);
			const agreements = settings.agreements || [];

			const agreement = {
				name: 'ostock',
				accepted: true,
				version: AGREEMENTS_VERSION.INVENTRO,
			};

			agreements.push(agreement);

			const updatedSettings = {
				agreements,
			};

			const callback = (response) => {
				// const user = duplicateVar(this.user);
				// user.settings = settings;
				const user = response.data;
				this.setUser(user);
				this.isAccepting = false;
				this.isVisible = false;
				this.$emit('accept');
			};
			const errorCallback = () => {
				this.isAccepting = false;
			};
			userApi.updateSettings(updatedSettings, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
		}),
		userId() {
			return this?.user?._id ?? '';
		},
		agreementUrl() {
			return this.user?.owner_type === 'supplier' ? this.supplierAgreementUrl : this.sellerAgreementUrl;
		},
	},
	created() {
		if (this.user) {
			this.checkAgreement();
		}
	},
	watch: {
		user() {
			if (this.user) {
				this.checkAgreement();
			}
		},
	},
};
</script>
